import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ['Spending as much time planning the practice as you spend running it', 'Half the team standing around while one group runs a drill', 'No set order to the season, so every week starts from a blank page', 'Digging through the binder mid-practice while the kids lose focus', "Players who can't remember the play — or the snap count — by game day", "Too many kids, not enough hands, and the parents who help don't know what to do", 'Knowing football, but not knowing how to run a practice', 'The season starts in two weeks and nothing is planned yet'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-navy-deep" data-id="element-166" data-mp="1brnvrsas2sn1">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-167" data-mp="17q2apjo3b81r">
        <div className="text-center" data-id="element-168" data-mp="3645dkkcul0ka">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-169" data-mp="3632kq6vyso1q">
            The coaching reality
          </p>
          <h2 id="pain-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl leading-tight sm:text-4xl md:text-5xl" data-id="element-170" data-mp="3g93c05vlrsrz">
            If you coach flag or youth football, you know at least{' '}
            <span className="text-crimson-soft" data-id="element-171" data-mp="379q95w1zi2g8">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-172" data-mp="3bas4i1ss5ucx">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl border border-navy-line bg-navy-card px-4 py-4 text-sm text-white/85" data-id="element-173" data-mp="2uyve80s3l5w">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-crimson/20" data-id="element-174" data-mp="3q6hnrs6kztdy">
                <XIcon className="h-3 w-3 text-crimson-soft" aria-hidden="true" data-id="element-175" data-mp="3u71kwvr5mx03" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-9 text-center font-display uppercase text-2xl leading-tight text-gold sm:text-3xl" data-id="element-176" data-mp="qkt6ol5g91o1">
          How many more practices do you want to make up the night before?
        </p>
      </div>
    </section>;
}